// Itens de navegacao do painel: fonte unica do menu lateral e da command palette.

import {
  Gauge,
  User,
  BarChart3,
  Users,
  DollarSign,
  Radio,
  Layers,
  Link as LinkIcon,
  History,
  FileEdit,
  Calendar,
  Download,
  Scissors,
  AtSign,
  ExternalLink,
  Store,
  MessageCircle,
  Building2,
  Settings,
  Crown,
  Puzzle,
  Zap,
  Shuffle,
  UserCheck,
  Repeat,
  Smartphone,
  TextQuote,
  type LucideIcon,
} from "lucide-react";

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
}

export interface NavSection {
  type: "section";
  label: string;
  children: NavItem[];
}

export type NavEntry = NavItem | NavSection;

export const navEntries: NavEntry[] = [
  // Início
  {
    type: "section",
    label: "Início",
    children: [
      { to: "/app", label: "Dashboard", icon: Gauge },
      { to: "/app/analytics", label: "Analytics", icon: BarChart3 },
      { to: "/app/analytics/membros", label: "Membros e inscritos", icon: UserCheck },
      { to: "/app/grupos", label: "Grupos e canais", icon: Users },
      { to: "/app/comissoes", label: "Comissões", icon: DollarSign },
    ],
  },
  // Afiliados
  {
    type: "section",
    label: "Afiliados",
    children: [
      { to: "/app/feed", label: "Feed de promoções", icon: Radio },
      { to: "/app/promocoes-automaticas", label: "Promoções automáticas", icon: Zap },
      { to: "/app/links", label: "Gerar Link", icon: LinkIcon },
      { to: "/app/links/massa", label: "Links em massa", icon: Layers },
      { to: "/app/conversoes", label: "Histórico", icon: History },
    ],
  },
  // Redes Sociais
  {
    type: "section",
    label: "Redes Sociais",
    children: [
      { to: "/app/criar-posts", label: "Criar Posts", icon: FileEdit },
      { to: "/app/calendario", label: "Calendário", icon: Calendar },
      { to: "/app/recorrentes", label: "Recorrentes", icon: Repeat },
      { to: "/app/textos-de-disparo", label: "Textos de disparo", icon: TextQuote },
      { to: "/app/stories", label: "Stories", icon: Smartphone },
      { to: "/app/downloads", label: "Downloads", icon: Download },
    ],
  },
  // Ferramentas
  {
    type: "section",
    label: "Ferramentas",
    children: [
      { to: "/app/encurtador", label: "Encurtador", icon: Scissors },
      { to: "/app/utm", label: "Gerador de UTMs", icon: AtSign },
      { to: "/app/bio", label: "Link na bio", icon: ExternalLink },
      { to: "/app/rodizio", label: "Rodízio de grupos", icon: Shuffle },
      { to: "/app/extensao", label: "Extensão Chrome", icon: Puzzle },
    ],
  },
  // Links avulsos (fora de seção)
  { to: "/app/vitrine", label: "Vitrine", icon: Store },
  { to: "/app/whatsapp", label: "WhatsApp", icon: MessageCircle },
  {
    type: "section",
    label: "Configurações",
    children: [
      { to: "/app/settings/empresa", label: "Empresa", icon: Building2 },
      { to: "/app/settings/personalizacao", label: "Personalização", icon: Settings },
      { to: "/app/settings/integracao", label: "Integrações", icon: Settings },
    ],
  },
  { to: "/app/plans", label: "Planos", icon: Crown },
  { to: "/app/account", label: "Minha conta", icon: User },
] as const;


/** Lista plana (secao + item) para a busca da command palette. */
export type FlatNavItem = NavItem & { section: string | null };

export function flatNavItems(): readonly FlatNavItem[] {
  return navEntries.flatMap((entry): FlatNavItem[] =>
    "type" in entry ? entry.children.map((child) => ({ ...child, section: entry.label })) : [{ ...entry, section: null }],
  );
}
